
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";

interface Plan {
  name: string;
  description: string;
  price: number;
  color: string;
  favorite?: boolean;
  alias: string;
  options: number[];
}
interface Model {
  plans: Record<string, Plan>;
  options: string[]; // Assuming options are strings mapped by index
}

export default Vue.extend({
  name: "SelectSubscriptionPage",

  data: () => ({
    model: {
      plans: {} as Record<string, Plan>,
      options: [] as string[]
    },
    selectedPlanAlias: "" as string,
    infoDialog: false,
    showInfoButton: false,
    termsAndConditionsDialog: false,
    exclusions: {} as Record<string, number[]>
  }),

  async beforeRouteEnter(to, from, next) {
    try {
      const response = await API.billing().getPlans();

      next(vm => {
        vm.model = response;

        // Process the plan option to build the exclusions
        const plans = vm.model.plans as Record<string, Plan>;
        const exclusions: Record<string, number[]> = {};


        // Get all unique options across all plans
        const allOptions = new Set<number>();
        for (const [slug, plan] of Object.entries(plans)) {
          if (slug === "business_new_2") continue;
          plan.options.forEach((opt: number) => allOptions.add(opt));
        }

        const allOptionArray = Array.from(allOptions);

        // Build exclusions
        for (const [slug, plan] of Object.entries(plans)) {
          console.log(slug, plan);
          if (slug === "business_new_2") {
            continue;
          }

          const missing = allOptionArray.filter(
            opt => !plan.options.includes(opt)
          );
          if (missing.length > 0) {
            exclusions[slug] = missing;
          }
        }

        vm.exclusions = exclusions;
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  mounted() {
    setTimeout(() => {
      this.showInfoButton = true;
    }, 1000);
  },

  methods: {
    async selectPlan() {
      try {
        const response = await API.stripe().selectSubscriptionPlan(
          this.selectedPlanAlias
        );

        this.$stripe.redirectToCheckout({
          sessionId: response.checkoutSession.id
        });
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    openTermsAndConditionsDialog(planAlias: string) {
      this.selectedPlanAlias = planAlias.split("_")[0];
      this.termsAndConditionsDialog = true;
    },
    confirmTermsAndConditions() {
      this.termsAndConditionsDialog = false;
      this.redirectToCheckout();
    },
    redirectToCheckout() {
      this.$router.push("/billing/plan/" + this.selectedPlanAlias);
    },
    isHeading(string: string) {
      return [
        "Personal Credit Services",
        "Business Credit Services",
        "Protection & Risk Management",
        "Business Growth Tools"
      ].includes(string);
    }
  }
});
